import { ClientsActionType } from './actions';
import { handleErrorInfo } from '../../utils';
import { ClientsState } from './interfaces';
import { prepareExportClientsCSV } from '../../utils/prepare-export-clients-csv';

const initialExportState = {
  loading: false,
  error: false,
  errorInfo: undefined,
  data: undefined,
  show: false,
};

const initialSummaryState = {
  loading: false,
  error: false,
  data: undefined,
};

const initialState: ClientsState = {
  loading: true,
  error: false,
  errorInfo: undefined,
  detail: null,
  allClients: undefined,
  summary: initialSummaryState,
  export: initialExportState,
};

const ClientsReducer = (state = initialState, action: { type: string; [key: string]: unknown }) => {
  switch (action.type) {
    case ClientsActionType.GET_CLIENTS: {
      return {
        ...state,
        loading: true,
        error: false,
        errorInfo: undefined,
      };
    }
    case ClientsActionType.GET_CLIENTS_SUCCESS: {
      return {
        ...state,
        loading: false,
        allClients: {
          ...(action.response as object),
        },
      };
    }
    case ClientsActionType.GET_CLIENTS_ERROR: {
      return {
        ...state,
        loading: false,
        error: true,
        errorInfo: handleErrorInfo(ClientsActionType.GET_CLIENTS_ERROR, action.error),
        allClients: undefined,
      };
    }
    case ClientsActionType.EXPORT_CLIENTS: {
      return {
        ...state,
        export: {
          ...state.export,
          loading: true,
          error: false,
          errorInfo: undefined,
          data: undefined,
        },
      };
    }
    case ClientsActionType.EXPORT_CLIENTS_SUCCESS: {
      const response = action.response as { text: string };
      return {
        ...state,
        export: {
          ...state.export,
          loading: false,
          data: prepareExportClientsCSV(response.text),
        },
      };
    }
    case ClientsActionType.EXPORT_CLIENTS_ERROR: {
      return {
        ...state,
        export: {
          ...state.export,
          loading: false,
          error: true,
          errorInfo: handleErrorInfo(ClientsActionType.EXPORT_CLIENTS_ERROR, action.error),
        },
      };
    }
    case ClientsActionType.RESET_EXPORT_CLIENTS: {
      return {
        ...state,
        export: initialExportState,
      };
    }
    case ClientsActionType.SHOW_EXPORT_CLIENTS: {
      return {
        ...state,
        export: {
          ...state.export,
          show: action.show as boolean,
          ...(action.show
            ? {
                loading: false,
                error: false,
                errorInfo: undefined,
                data: undefined,
              }
            : {}),
        },
      };
    }
    case ClientsActionType.SET_CLIENT_DETAIL: {
      return {
        ...state,
        detail: action.client as ClientsState['detail'],
      };
    }
    case ClientsActionType.GET_CLIENTS_SUMMARY: {
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: true,
          error: false,
        },
      };
    }
    case ClientsActionType.GET_CLIENTS_SUMMARY_SUCCESS: {
      return {
        ...state,
        summary: {
          loading: false,
          error: false,
          data: action.summary as ClientsState['summary']['data'],
        },
      };
    }
    case ClientsActionType.GET_CLIENTS_SUMMARY_ERROR: {
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          error: true,
        },
      };
    }
    case ClientsActionType.DELETE_CLIENT_SUCCESS: {
      const clientId = action.clientId as number;
      const data = state.allClients?.data?.filter(client => client.id !== clientId);

      return {
        ...state,
        allClients: state.allClients
          ? {
              ...state.allClients,
              data: data ?? [],
              totalElements: Math.max((state.allClients.totalElements ?? 1) - 1, 0),
            }
          : undefined,
      };
    }
    default:
      return state;
  }
};

export default ClientsReducer;
